export const loadList = (db, collection) => {
  return db
    .collection(collection)
    .where('isActive', '==', true)
    .orderBy('modifiedOn', 'asc')
    .get()
    .then(result => {
      return result.docs.map(doc => {
        return { ...doc.data(), id: doc.id };
      });
    });
};
